<div class="change-settings-dialog">
    @switch (action()) {
        @case ('changeName') {
            <form [formGroup]="changeNameForm" (ngSubmit)="executeAction()">
                <div>
                    <div class="label-wrapper">
                        <form-label [label]="labels.zoneName"></form-label>
                        <div class="counter">{{ zoneNameCounter() }}</div>
                    </div>
                    <form-text-input [inputControl]="newNameControl"
                                     [placeholder]="zoneNamePlaceholder()"
                                     [maxLength]="maxZoneNameLength">
                    </form-text-input>
                </div>
            </form>
        }
        @case ('changeIcon') {
            <div class="icons">
                @for (icon of icons; track icon.iconId) {
                    <div class="icon-wrapper" [class.bg-style]="icon.iconName === selectedIcon()?.iconName" (click)="selectIcon(icon)">
                        <zone-icon [name]="icon.iconName"
                                   [size]="16"
                                   [light]="icon.iconName === selectedIcon()?.iconName">
                        </zone-icon>
                    </div>
                }
            </div>
        }
    }
    <form-action-buttons>
        <form-button [subtitle]="labels.cancel" [btnType]="'cancel'" (click)="closeDialogClick()"/>
        <form-button [subtitle]="actionLabel()" [btnType]="'confirm'" (click)="executeAction()"/>
    </form-action-buttons>
</div>
